import React from 'react';
import Home from './pages/home/homepage.component';

function App() {
	return <Home />;
}

export default App;
